import React, { useEffect, useState, useRef } from 'react';
import {
  Container,
  Button,
  Spinner,
  Alert,
  Row,
  Col,
  Card,
  CardBody,
  Collapse
} from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
// Hanya menggunakan fetchCategories dan fetchPaketBacaan
import { fetchCategories, fetchPaketBacaan } from '../../../services/bacaanService';
import { FiChevronRight, FiArrowLeft, FiChevronDown } from 'react-icons/fi';

const PaketDetailBacaan = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [namaSeleksi, setNamaSeleksi] = useState('');
  const [fetchedBidangOptions, setFetchedBidangOptions] = useState([]);
  const [selectedBidang, setSelectedBidang] = useState({ id: null, name: 'ALL - Semua Kategori' });
  const [allSeleksi, setAllSeleksi] = useState([]); // State untuk daftar semua tahun SKD
  const [openCategoriesId, setOpenCategoriesId] = useState(null);
  const [masterPaketList, setMasterPaketList] = useState([]); // State untuk daftar master_paket (semua paket untuk SKD terpilih)

  const isInitialFetchDone = useRef(false);

  const getIdFromUrl = (param) => {
    const query = new URLSearchParams(location.search);
    return query.get(param);
  };

  const idJenisSeleksi = getIdFromUrl("id_jenis_seleksi");

  const updateQueryParam = (param, value) => {
    const query = new URLSearchParams(location.search);
    if (value === null) {
      query.delete(param);
    } else {
      query.set(param, value);
    }
    navigate(`${location.pathname}?${query.toString()}`, { replace: true });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const idJenisFromUrl = getIdFromUrl("id_jenis_seleksi");
        const idBidangFromUrl = getIdFromUrl("id_bidang");

        // Panggil fetchCategories untuk mendapatkan semua daftar SKD dan kategori yang relevan
        // Jika idJenisFromUrl tidak ada, fetchCategories akan mengembalikan data default
        const {
          namaSeleksi: fetchedNamaSeleksi,
          bidangOptions: fetchedBidangOpts,
          allSeleksi: fetchedAllSeleksiData
        } = await fetchCategories(idJenisFromUrl);

        setAllSeleksi(fetchedAllSeleksiData); // Set semua tahun SKD yang tersedia
        setNamaSeleksi(fetchedNamaSeleksi);

        // Filter out "ALL - Semua Kategori" from fetched options for mapping,
        // karena sudah ditambahkan secara manual di bawah
        setFetchedBidangOptions(fetchedBidangOpts.filter(option => option.id !== null));

        let currentOpenCategoriesId = null;
        if (idJenisFromUrl) {
            currentOpenCategoriesId = idJenisFromUrl;
        } else if (fetchedAllSeleksiData.length > 0) {
            // Jika tidak ada id_jenis_seleksi di URL, default ke SKD pertama
            currentOpenCategoriesId = fetchedAllSeleksiData[0].id_jenis_soal;
            updateQueryParam("id_jenis_seleksi", defaultSkd.id_jenis_soal); // Perbarui URL
        }
        setOpenCategoriesId(currentOpenCategoriesId);

        // Tentukan kategori yang dipilih dari URL
        const currentSelectedBidang = fetchedBidangOpts.find(opt => String(opt.id) === String(idBidangFromUrl)) || { id: null, name: 'ALL - Semua Kategori' };
        setSelectedBidang(currentSelectedBidang);

        // Ambil data master_paket (materi bacaan) berdasarkan id_jenis_seleksi
        if (currentOpenCategoriesId) {
            const paketData = await fetchPaketBacaan(currentOpenCategoriesId);
            setMasterPaketList(paketData); // Simpan semua paket yang diambil
        } else {
            setMasterPaketList([]);
        }

        isInitialFetchDone.current = true;
      } catch (err) {
        console.error("Error:", err);
        setError(err.message || "Gagal memuat data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [location.search]); // Bergantung pada perubahan URL

  const handleSelectBidang = (id, name) => {
    setSelectedBidang({ id, name });
    updateQueryParam("id_bidang", id);
  };

  const toggleCategories = (id_jenis_soal) => {
    setOpenCategoriesId(prevId => (prevId === id_jenis_soal ? null : id_jenis_soal));
    updateQueryParam("id_jenis_seleksi", id_jenis_soal);
    updateQueryParam("id_bidang", null);
  };

  const handleBack = () => navigate(-1);

  // Filter masterPaketList berdasarkan selectedBidang secara client-side
  const filteredPaketList = masterPaketList.filter(paket => {
    if (selectedBidang.id === null) {
      return true; // Tampilkan semua jika "ALL - Semua Kategori" dipilih
    }
    // Asumsi: paket.categories (misal "PPKN") adalah bagian dari selectedBidang.name (misal "TWK - PPKN")
    // Anda mungkin perlu menyesuaikan logika perbandingan ini jika formatnya berbeda
    // Misalnya, jika paket.categories adalah "PPKN" dan selectedBidang.name adalah "TWK - PPKN",
    // maka selectedBidang.name.includes(paket.categories) akan benar.
    return selectedBidang.name.includes(paket.categories);
  });

  if (loading && !isInitialFetchDone.current) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <Alert color="info" className="text-center d-flex align-items-center">
          <Spinner size="sm" className="me-2" /> Memuat data...
        </Alert>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <Alert color="danger" className="text-center">
          <h5 className="alert-heading">Terjadi Kesalahan</h5>
          <p>{error}</p>
          <Button color="danger" onClick={() => window.location.reload()} size="sm">
            Coba Lagi
          </Button>
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="pt-5 pb-4">

      <div className="mb-4" style={{marginTop: '50px'}}>
        <div className="d-flex overflow-auto gap-2 pb-3" style={{ whiteSpace: 'nowrap' }}>
          {allSeleksi.map((paket) => {
            const isActive = String(paket.id_jenis_soal) === String(getIdFromUrl("id_jenis_seleksi"));
            const isOpen = String(paket.id_jenis_soal) === String(openCategoriesId);
            return (
              <Button
                key={paket.id_jenis_soal}
                color={isActive ? "primary" : "outline-secondary"}
                className={`fw-bold flex-shrink-0 px-3 ${isActive ? 'text-white' : 'text-dark'}`}
                onClick={() => toggleCategories(paket.id_jenis_soal)}
              >
                {paket.nama_seleksi} {isOpen ? <FiChevronDown className="ms-1" /> : <FiChevronRight className="ms-1" />}
              </Button>
            );
          })}
        </div>

        {/* Render kategori untuk tahun SKD yang dipilih */}
        {allSeleksi.map((paket) => {
            const isOpen = String(paket.id_jenis_soal) === String(openCategoriesId);
            const categoriesArray = Object.entries(paket.categories || {}).map(([id, name]) => ({
              id: id,
              name: name
            }));

            // Hanya tampilkan kategori untuk paket yang sedang terbuka
            if (String(paket.id_jenis_soal) !== String(openCategoriesId)) {
                return null;
            }

            return (
                <Collapse isOpen={isOpen} key={`collapse-${paket.id_jenis_soal}`}>
                    <Card className="mt-3 shadow-sm border-0">
                        <CardBody>
                            <h6 className="mb-3 text-dark">Kategori {paket.nama_seleksi}</h6>
                            <div className="d-flex flex-wrap gap-2">
                                {/* Opsi "ALL - Semua Kategori" */}
                                <Button
                                    color={selectedBidang.id === null ? "primary" : "outline-secondary"}
                                    onClick={() => handleSelectBidang(null, 'ALL - Semua Kategori')}
                                    className="flex-shrink-0"
                                >
                                    ALL - Semua Kategori
                                </Button>
                                {categoriesArray.map((category) => (
                                    <Button
                                        key={category.id}
                                        color={String(selectedBidang.id) === String(category.id) ? "primary" : "outline-secondary"}
                                        onClick={() => handleSelectBidang(category.id, category.name)}
                                        className="flex-shrink-0"
                                    >
                                        {category.name}
                                    </Button>
                                ))}
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>
            );
        })}
      </div>

      {/* Informasi kategori yang sedang dipilih */}

      <h5 className="mb-3 text-dark">Daftar Materi</h5>
      {filteredPaketList.length > 0 ? (
        <Row xs="1" md="2" lg="3" className="g-4"> {/* Responsive grid for cards */}
          {filteredPaketList.map((paket) => (
            <Col key={paket.id_paket}>
              <Card className="h-100 shadow-sm border-0 rounded-lg">
                <CardBody className="d-flex flex-column">
                  <div className="d-flex align-items-center mb-3">
                    {/* Placeholder for icon, you can replace with actual icon/image */}
                    <div className="bg-light p-3 rounded-circle me-3">
                      <FiChevronRight size={24} className="text-primary" /> {/* Contoh ikon */}
                    </div>
                    <div>
                      <h6 className="mb-0 text-dark">{paket.nama_paket}</h6>
                      {/* Asumsi: paket.nama_jenis dan paket.categories tersedia di respons API fetchPaketBacaan */}
                      <small className="text-muted">{paket.nama_jenis} - {paket.categories}</small>
                    </div>
                    {paket.is_premium && (
                      <span className="badge bg-warning text-dark ms-auto">Premium</span>
                    )}
                  </div>
                  <p className="text-muted small flex-grow-1">{paket.deskripsi || 'Tidak ada deskripsi.'}</p>
                  <Button
                    color="primary"
                    className="mt-auto"
                    onClick={() => {
                        navigate(`/list-bacaan?id_jenis_soal=${paket.id_jenis_soal}&id_jenis_seleksi=${paket.id_jenis_seleksi}&id_kategori_paket=${paket.id_kategori_paket}&kategori=${encodeURIComponent(paket.categories || '')}`);
                    }}
                    >
                    Baca Materi <FiChevronRight className="ms-1" />
                    </Button>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <Card className="border-0 shadow-sm">
          <CardBody className="p-4">
            <div className="text-center py-5">
              <h5 className="text-secondary mb-3">Tidak ada materi yang tersedia.</h5>
              <p className="text-muted">
                Silakan pilih tahun SKD dan kategori untuk melihat materi.
              </p>
            </div>
          </CardBody>
        </Card>
      )}
    </Container>
  );
};

export default PaketDetailBacaan;
